import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { useModel } from '@umijs/max';

type AuthContextValue = {
  user?: API.CurrentUser;
  authenticated: boolean;
};

const AuthContext = createContext<AuthContextValue>({
  user: undefined,
  authenticated: false,
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const { initialState } = useModel('@@initialState');
  const value = {
    user: initialState?.currentUser,
    authenticated: Boolean(initialState?.currentUser),
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export function useAuth() {
  return useContext(AuthContext);
}
